import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaChartLine, FaTachometerAlt } from 'react-icons/fa'
import {
  StepCard,
  StepHeader,
  MetricsCardContainer,
  MetricsCardInner,
  MetricsCardFront,
  MetricsCardBack,
  MetricsChartContainer,
  GaugeColumn,
} from '../ModelPerformanceCard.styles'
import GaugeMetricCard from './GaugeMetricCard'
import { useAppSelector } from '../../../../store/hooks'
import { useGetModelQuery } from '../../../../services/modelsApi'
import { selectSelectedModelId } from '../../../../store/slices/modelSlice'
import BBoxPerformanceMetricsChart from '../../../views/ModelTrainingView/BBoxPerformanceMetricsChart'
import LossValuesChart from '../../../views/ModelTrainingView/LossValuesChart'

interface BBoxMetricsCardProps {
  gradients: {
    metrics: string
  }
  metrics: Array<{
    key: string
    value: number
  }>
}

const BBoxMetricsCard: React.FC<BBoxMetricsCardProps> = ({ gradients, metrics }) => {
  const [isMetricsFlipped, setIsMetricsFlipped] = React.useState(false)
  const selectedModelId = useAppSelector(selectSelectedModelId)
  const { data: selectedModel } = useGetModelQuery(selectedModelId || '', {
    skip: !selectedModelId,
  })

  return (
    <MetricsCardContainer>
      <MetricsCardInner $isFlipped={isMetricsFlipped}>
        <MetricsCardFront>
          <StepCard>
            <StepHeader $gradient={gradients.metrics}>
              Performance Metrics
              <FaTachometerAlt />
              <div style={{ marginLeft: 'auto' }}>
                <button
                  onClick={() => setIsMetricsFlipped(true)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                  }}
                  aria-label="Show metrics graph"
                >
                  <FaChartLine size={16} />
                </button>
              </div>
            </StepHeader>

            <div className="metrics-step-content">
              <Row className="g-2">
                {metrics.map(({ key, value }, index) => (
                  <GaugeColumn key={key} xs={12} sm={12} lg={6} index={index}>
                    <GaugeMetricCard metricKey={key} value={value} />
                  </GaugeColumn>
                ))}
              </Row>
            </div>
          </StepCard>
        </MetricsCardFront>

        <MetricsCardBack>
          <StepCard>
            <StepHeader $gradient={gradients.metrics}>
              Metrics Over Time
              <FaChartLine />
              <div style={{ marginLeft: 'auto' }}>
                <button
                  onClick={() => setIsMetricsFlipped(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                  }}
                  aria-label="Show metrics gauges"
                >
                  <FaTachometerAlt size={16} />
                </button>
              </div>
            </StepHeader>
            <MetricsChartContainer>
              <Row>
                <Col>
                  <BBoxPerformanceMetricsChart model={selectedModel} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LossValuesChart model={selectedModel} />
                </Col>
              </Row>
            </MetricsChartContainer>
          </StepCard>
        </MetricsCardBack>
      </MetricsCardInner>
    </MetricsCardContainer>
  )
}

export default BBoxMetricsCard
